import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-etudes',
  templateUrl: './home-etudes.component.html',
  styleUrls: ['./home-etudes.component.scss']
})
export class HomeEtudesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
